import React from 'react';
import { Button } from 'components/button';
import DosageScheduleTable from './dosage-schedules-table';
import { Link } from 'react-router-dom';
import { routes } from 'utils/routes';

const DosageSchedulesPage = (): React.ReactElement => {
  return (
    <section>
      <div className=" min-w-full">
        <div className="min-w-full flex justify-end">
          <Link to={routes.createDosageSchedule}>
            <Button variant="outline">Create New</Button>
          </Link>
        </div>
        <DosageScheduleTable />
      </div>
    </section>
  );
};

export default DosageSchedulesPage;
